<template>
  <div class="main-content wide with-sidebar">
    <div class="wrap">
      <sidebar-left />
      <div class="page-main-block">
        <h1>{{ pageData.pageTitle }}</h1>
        <div
          v-dompurify-html="pageData.description"
          class="description"
        />
        <template v-for="(item, itemKey) in pageData.content">
          <div
            v-if="item.type === 'wysiwyg'"
            :key="`wysiwyg_${itemKey}`"
            v-dompurify-html="item.text"
            class="text"
          />

          <div
            v-else-if="item.type === 'list'"
            :key="`list_${itemKey}`"
            class="list"
          >
            <div
              v-for="(listItem, itemIndex) in item.data"
              :key="itemIndex"
              class="list-item"
            >
              <div class="img-wrap">
                <img
                  width="42"
                  height="42"
                  :src="listItem.image"
                  :alt="`Icon ${itemIndex}`"
                />
              </div>
              <span
                v-dompurify-html="listItem.text"
                :style="'before'"
              />
            </div>
          </div>

          <vertical-table
            v-else
            :key="itemKey"
            :table-data="JSON.parse(item.tableData)"
            :header-images-classes="classes"
          />
        </template>

        <compare-table
          :table-data="pageData.tableData"
          :header="pageData.header"
          :header-images-classes="classes"
        />

        <div
          v-if="pageData.bottomContent"
          v-dompurify-html="pageData.bottomContent"
          class="text"
        />

        <terms-and-conditions
          v-if="termsAndConditions.content"
          :title="termsAndConditions.title"
          :content="termsAndConditions.content"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import SidebarLeft from 'components/Sidebar/Sidebar'
  import CompareTable from 'components/Tables/CompareTable'
  import VerticalTable from 'components/Tables/VerticalTable'
  import TermsAndConditions from 'components/TermsAndConditions'

  export default {
    components: {
      SidebarLeft,
      TermsAndConditions,
      CompareTable,
      VerticalTable
    },

    data() {
      return {
        classes: ['BASIC', 'EX', 'VIP']
      }
    },
    computed: {
      ...mapState('compareTable', ['pageData', 'termsAndConditions'])
    }
  }
</script>

<style
  lang="scss"
  scoped
  rel="stylesheet/scss"
>
  @import '~assets/styles/common.scss';

  .with-sidebar {
    padding: 26px 0 0;

    @include bp-tablet-only {
      padding: 45px 0 0;
    }

    @include bp-mf-desktop {
      padding: 45px 0 0;
    }

    h1 {
      margin: 2px 0 25px;
      font-size: em(40);
      font-weight: 300;

      @include bp-tablet {
        margin: 0 0 11px;
      }

      @include bp-mobile {
        margin-bottom: 12px;
        font-size: em(32);
        word-wrap: break-word;
      }

      @include bp-mf-tablet {
        margin: 0 0 12px;
        padding: 0;
        font-size: em(40);
      }
    }

    .wrap {
      display: flex;
      flex-direction: column;
      @include clearfix();

      @include bp-mf-desktop {
        display: block;
      }
    }

    .description {
      /deep/ p {
        margin: 0 0 25px;
        line-height: 24px;
        font-size: em(16);
        font-weight: 300;

        .js-inline-button {
          font-size: em(15, 16);
        }

        @include bp-mf-tablet {
          padding: 0;
          margin-bottom: 32px;
          font-size: em(18);
          line-height: 27px;

          .js-inline-button {
            font-size: em(15, 18);
          }
        }

        @include bp-mf-desktop {
          margin-bottom: 28px;
          font-size: em(20);

          .js-inline-button {
            font-size: em(15, 20);
          }
        }
      }
    }

    /deep/ b,
    /deep/ strong {
      font-weight: 500;
    }
  }

  .page-main-block {
    order: 1;
    padding: 0 24px 30px;

    @include bp-tablet-only {
      padding: 0 26px 42px;
    }

    @include bp-mf-desktop {
      padding: 0 0 62px;
      float: left;
      vertical-align: top;
      width: 66%;
    }
  }

  .text {
    font-size: em(14);
    line-height: 21px;
  }

  .list {
    padding: 20px 0 0;
  }

  .list-item {
    padding: 0 0 25px 10px;
    font-size: em(16);
    line-height: 37px;

    @include bp-mf-tablet {
      width: 50%;
      display: inline-block;
      padding-right: 20px;
    }

    .img-wrap {
      display: inline-block;
      float: left;
      width: 42px;
    }

    img {
      max-width: 42px;
      vertical-align: middle;
    }

    span {
      width: calc(100% - 42px);
      padding-left: 15px;
      display: inline-block;
      vertical-align: middle;
      line-height: 24px;
    }

    /deep/ p {
      margin: 0;
    }

    /deep/ a:not(.js-inline-button) {
      color: $blue-medium;

      &:hover {
        color: $blue-light;
      }
    }
  }
</style>
